import { GridCell, GridCellProps } from '@mui/x-data-grid-pro';
import React from 'react';

export function ChildTableCell({ rowId, column, ...rest }: GridCellProps): JSX.Element {
	const commonProps = {
		rowId,
		column,
		...rest,
		'data-testid': `cell-${column.field}`,
	};

	return <GridCell {...commonProps} />;
}
